export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkProducts: "nav-link-products",
  linkHow: "nav-link-how",
  linkServices: "nav-link-services",
  linkIndustries: "nav-link-industries",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaQuote: "nav-cta-quote",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  ctaQuote: "hero-cta-quote",
  ctaProducts: "hero-cta-products",
};

export const PRODUCTS = {
  root: "products-section",
  card: (slug) => `product-card-${slug}`,
  enquire: (slug) => `product-enquire-${slug}`,
};

export const CONTACT = {
  root: "contact-section",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  city: "contact-city",
  company: "contact-company",
  requirement: "contact-requirement",
  message: "contact-message",
  submit: "contact-submit",
  successAlert: "contact-success",
};

export const CHAT = {
  toggle: "chatbot-toggle",
  panel: "chatbot-panel",
  input: "chatbot-input",
  send: "chatbot-send",
  close: "chatbot-close",
  messages: "chatbot-messages",
};
